import { jsx as _jsx } from "react/jsx-runtime";
import { filterDuplicates, generateHex, sortArray } from '@nu-art/ts-common';
import { defaultItem_SmartDocStaticParam, smartDocParamType_External } from '@app/advisor-content-shared';
// ######################## Translation of log template to preview text ########################
export const translateLogTemplateToNodes = (template) => {
    const nodes = [];
    if (template.title)
        nodes.push(_jsx("b", { children: template.title }, generateHex(5)), _jsx("br", {}, generateHex(5)));
    template.sections.forEach(section => {
        nodes.push(`${section}\n`);
    });
    return nodes;
};
// ######################## Extraction of param keys from log template ########################
const paramRegex = new RegExp(/\{([^{}]*)\}/g);
export const extractParamKeysFromLogTemplate = (template) => {
    const paramKeys = [];
    if (template.title) {
        const matches = template.title.matchAll(paramRegex);
        for (const match of matches)
            paramKeys.push(match[1]);
    }
    template.sections.forEach(section => {
        const matches = section.matchAll(paramRegex);
        for (const match of matches)
            paramKeys.push(match[1]);
    });
    return filterDuplicates(paramKeys);
};
// ######################## Param Builder for log template ########################
export const logTemplateParamBuilder = (paramKeys, existingParams) => {
    const params = existingParams.filter(param => param.type === smartDocParamType_External || paramKeys.includes(param.key));
    const existingParamKeys = params.map(p => p.key);
    const paramsToCreateKeys = paramKeys.filter(key => !existingParamKeys.includes(key));
    //Start out each new param as a static param
    const newParams = paramsToCreateKeys.map(key => defaultItem_SmartDocStaticParam(key));
    params.push(...newParams);
    return sortArray(params, param => param.key);
};
//# sourceMappingURL=utils.js.map